import "./Login.scss"
import React, { useState } from "react"
import { ToggleButton, ToggleButtonGroup } from "@mui/material"
import { useAppDispatch } from "../../redux/hooks"
import ForgotPasswordModal from "../../components/Modals/ForgotPasswordModal/ForgotPasswordModal.component"
import {
  hideModal,
  ModalTypes,
  selectActiveModal,
} from "../../redux/slices/modalSlice"
import { useSelector } from "react-redux"
import { useTranslationLabel } from "../../hooks/useTranslationLabel"
import EmailLogin from "./EmailLogin/EmailLogin"
import PhoneLogin from "./PhoneLogin/PhoneLogin"
import { useBranding } from "../../hooks/useBranding";
import { useIsGoTo } from "../../hooks/useIsGoTo"

const Login = () => {
  const { name } = useIsGoTo();
  const [loginType, setLoginType] = useState("email")
  const dispatch = useAppDispatch()
  const { logo } = useBranding();
  const activeModal: ModalTypes | null = useSelector(selectActiveModal)

  const handleCloseModal = () => {
    dispatch(hideModal())
  }
  const { LOGIN_TITLE, INPUT_EMAIL, INPUT_PHONE } = useTranslationLabel()

  const handleLoginTypeChange = (
    e: React.MouseEvent<HTMLElement>,
    newLoginType: string,
  ) => {
    if (newLoginType !== null) {
      setLoginType(newLoginType)
    }
  }
  return (
    <div className="login-container column">
      <h2 className="title">{LOGIN_TITLE}</h2>
      <img src={logo} className={`app-logo-${name}`} alt="" />

      <ToggleButtonGroup
        className="toggle-button-group flex"
        value={loginType}
        exclusive
        onChange={handleLoginTypeChange}
        aria-label="login-type"
      >
        <ToggleButton value="email" className="toggle-button">
          {INPUT_EMAIL}
        </ToggleButton>
        <ToggleButton value="phone" className="toggle-button">
          {INPUT_PHONE}
        </ToggleButton>
      </ToggleButtonGroup>

      {loginType === "email" ? <EmailLogin /> : <PhoneLogin />}

      {activeModal && (
        <>
          <ForgotPasswordModal
            open={activeModal === ModalTypes.FORGOT_PASSWORD_MODAL}
            handleClose={handleCloseModal}
          />
        </>
      )}
    </div>
  )
}

export default Login
